export const AUTH = "AUTH";
export const AUTHERROR = "AUTHERROR";
export const LOGOUT = "LOGOUT";
export const CREATE = "CREATE";
export const CREATE_CLIENTS = "CREATE_CLIENTS";
export const UPDATE = 'UPDATE';
export const DELETE = "DELETE";
export const FETCH_ALL = "FETCH_ALL";
export const FETCH_ALL_FOURNISSEURS = "FETCH_ALL_FOURNISSEURS";
export const FETCH_ALL_CLIENTS = "FETCH_ALL_CLIENTS";
export const FETCH_ALL_CHECKS = "FETCH_ALL_CHECKS";
export const FETCH_ALL_PAYMENTS = "FETCH_ALL_PAYMENTS";
export const SET_PAYMENT_ID = "SET_PAYMENT_ID";
export const FILTER_FOURNISSEUR_CHECKS = "FILTER_FOURNISSEUR_CHECKS";
export const SEARCH_FOURNISSEURS = 'SEARCH_FOURNISSEURS';
export const FETCH_ALL_CHECK_CLIENTS = "FETCH_ALL_CHECK_CLIENTS";
export const CREATE_CHECK_CLIENT = "CREATE_CHECK_CLIENT";
export const UPDATE_CHECK_CLIENT = "UPDATE_CHECK_CLIENT";
export const DELETE_CHECK_CLIENT = "DELETE_CHECK_CLIENT";
export const FILTER_CHECK_CLIENTS = "FILTER_CHECK_CLIENTS";
export const SEARCH_CLIENT = "SEARCH_CLIENT";
